import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchGrouptripsDtlbannersec } from "../services/GrouptripsDtlbannersec";
import { API_BASE } from "../api/apiConfig";

const GrouptripsDtlbannersec = () => {
  const { id,type } = useParams();
  const [GroupTripsDtl, setCustomizedTripsDtl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchGrouptripsDtlbannersec(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setCustomizedTripsDtl(res.data[0]); 
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  // NEW: destination count from covered_place
const destinationCount = GroupTripsDtl?.covered_place
  ? GroupTripsDtl.covered_place
      .split(",")
      .map(p => p.trim())
      .filter(Boolean).length
  : 0;


  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!GroupTripsDtl) return <p className="text-center py-10">No GroupTripsDtl found</p>;

  return (
     
     <>

      {/* ================= HEADER IMAGE & TOP BAR ================= */}
        <section className="relative bg-slate-900">
          {/* Top Buttons */}
          <div className="absolute left-0 right-0 top-0 z-10 flex items-center justify-between px-4 pt-4 md:px-4 md:pt-6">
            {/* Back Button */}
        <a href="/grouptrips"> 
            <button className="justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-10 group flex items-center gap-1 rounded-full border-white/30 bg-black/40 px-3 py-1.5 text-white backdrop-blur-lg hover:bg-black/60 hover:text-white md:px-4 md:py-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-left h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1 md:h-4 md:w-4"
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
              <span className="text-sm font-medium md:text-sm">Back</span>
            </button>
        </a>
            {/* Share Button */}
            <button className="justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border h-10 flex items-center gap-1.5 rounded-full border-white/30 bg-black/40 px-3 py-1.5 text-white backdrop-blur-lg hover:bg-black/60 hover:text-white md:px-4 md:py-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-share2 h-4 w-4 md:h-4 md:w-4"
              >
                <circle cx={18} cy={5} r={3} />
                <circle cx={6} cy={12} r={3} />
                <circle cx={18} cy={19} r={3} />
                <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
                <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
              </svg>
              <span className="text-sm font-medium md:text-sm">Share</span>
            </button>
          </div>

          {/* HEADER IMAGE & OVERLAY */}
          <div className="relative h-[32vh] min-h-[240px] w-full md:h-[50vh] lg:h-[60vh]">
            <img
              alt="Winter Spiti 4x4 Expedition"
              decoding="async"
              data-nimg="fill"
              className="object-cover"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                color: "transparent",
              }}
              src={
              GroupTripsDtl?.images
                ? `${API_BASE}${GroupTripsDtl.images}`
                : `${API_BASE}default.jpg`
            }
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-slate-900/30" />
          </div>

          {/* HEADER TEXT & TAGS */}
          <div className="container absolute bottom-0 left-0 right-0 mx-auto px-4 py-4 md:px-4 md:py-10 lg:py-12 text-white">
            {/* TAGS */}
            <div className="flex flex-wrap items-center gap-1.5 md:gap-2 mb-3">
             
            {GroupTripsDtl.categorydata && (
              <div className="inline-flex items-center rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-primary text-white border-none hover:bg-primary/90 text-xs md:text-xs px-2 py-0.5 md:px-2 font-medium">
                {GroupTripsDtl.categorydata}
              </div>
            )}
            {GroupTripsDtl.difficulty && (
              <div className="inline-flex items-center rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-white/20 backdrop-blur-sm border-none hover:bg-white/30 text-xs md:text-xs px-2 py-0.5 md:px-2 font-medium">
                {GroupTripsDtl.difficulty}
              </div>
            )}
              {GroupTripsDtl.tage && Number(GroupTripsDtl.tage) !== 0 && (
                  <div class="inline-flex items-center rounded-full border transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-green-500/90 text-white border-none hover:bg-green-500 text-xs md:text-xs px-2 py-0.5 md:px-2 font-medium"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-tag mr-1 h-3 w-3 md:mr-1 md:h-3 md:w-3"><path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z"></path><path d="M7 7h.01"></path></svg>{GroupTripsDtl.tage}</div>
              )}
              
              <div className="flex items-center bg-black/30 rounded-full px-2 py-0.5 md:px-2.5 md:py-1 text-white/90">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star mr-1 h-3 w-3 md:mr-1 md:h-3 md:w-3 text-yellow-400 fill-yellow-400"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <span className="text-xs md:text-xs font-medium">
                  4.9 ({142})
                </span>
              </div>
            </div>

            {/* Title */}
            <h1 className="mt-2 text-xl font-bold leading-tight md:mt-3 md:text-3xl lg:text-4xl drop-shadow-sm">
              {GroupTripsDtl.name}
            </h1>

            {/* Info */}
            <div className="mt-2.5 flex flex-wrap items-center gap-x-3 gap-y-1.5 md:mt-6 md:gap-x-6 md:gap-y-3">
              {/* Duration */}
              <div className="flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-calendar h-4 w-4 md:h-5 md:w-5 text-primary"
                >
                  <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                  <line x1={16} x2={16} y1={2} y2={6} />
                  <line x1={8} x2={8} y1={2} y2={6} />
                  <line x1={3} x2={21} y1={10} y2={10} />
                </svg>
                <span className="text-sm md:text-base">{GroupTripsDtl.duration} / {GroupTripsDtl.no_of_days} days</span>
              </div>
              {/* Location */}
              <div className="flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-map-pin h-4 w-4 md:h-5 md:w-5 text-primary"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx={12} cy={10} r={3} />
                </svg>
                <span className="text-sm md:text-base">{GroupTripsDtl.city}</span>
              </div>
              {/* Max People */}
          {GroupTripsDtl.spots && (
              <div className="flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-users h-4 w-4 md:h-5 md:w-5 text-primary"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx={9} cy={7} r={4} />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                <span className="text-sm md:text-base">Max {GroupTripsDtl.spots}</span>
              </div>
          )}
            </div>
          </div>
        </section>

    </>

 
  );
};

export default GrouptripsDtlbannersec;
